export default "__VITE_ASSET__IDyAjkBT__"